import React, { ReactNode } from 'react';
import { Inline } from '@balance-web/inline';

export const Actions = ({ children }: { children: ReactNode }) => {
  return <Inline gap="small">{children}</Inline>;
};
